export const fetchJSON = async <ResponseType>(
    url: RequestInfo,
    args: RequestInit = {},
    appendHeaders?: boolean,
): Promise<ResponseType> => {
    const res = await fetch(url, args);
    const json = await res.json();
    if (res.status < 200 || res.status >= 400) {
        throw json;
    }
    if (appendHeaders) {
        json["headers"] = res.headers;
    }
    return json;
};

export const fetchJSONAndHeaders = async <ResponseType>(
    url: RequestInfo,
    args: RequestInit = {},
): Promise<[ResponseType, Headers]> => {
    const res = await fetch(url, args);
    const json = await res.json();
    if (res.status < 200 || res.status >= 400) {
        throw json;
    }
    return [json, res.headers];
};
